import { ENGLISH_TRANSLATE } from 'assets/translate/en';
import { SPANISH_TRANSLATE } from 'assets/translate/es';
import { PORTUGUESE_TRANSLATE } from 'assets/translate/pt';
import { TRANSLATOR_ACTIONS } from 'constants/Actions/Translator';
import { LANGUAGES } from 'constants/Languages';
import { setLanguageLocalStorange } from 'redux/services/StorageServices';
import { actionDispatch } from './SharedActions';

/**
 * Función que recibe como parametro el indicador de la traduccion y 
 *  realiza la misma mediante el plugin i18n.
 * 
 * @param {string} sKey Fecha que se desea transformar en objeto
 * 
 * @returns {string}
 */
export const GetTranslation = (sLanguage, sKey) => {
    switch (sLanguage) {
        case LANGUAGES.ENGLISH:
            return ENGLISH_TRANSLATE[sKey] ?? sKey;
        case LANGUAGES.PORTUGUESE:
            return PORTUGUESE_TRANSLATE[sKey] ?? sKey;
        case LANGUAGES.SPANISH:
        default:
            return SPANISH_TRANSLATE[sKey] ?? sKey;
    }
}
/**
 * Función que envia a cambiar el idioma establecido en el reducer.
 * 
 * @param {string} sLanguage Nuevo idioma que se seteara
 */
export const actionChangeLanguage = (sLanguage) => {
    return dispatch => {
        setLanguageLocalStorange(sLanguage).then(() => {
            dispatch(actionDispatch(TRANSLATOR_ACTIONS.GET, sLanguage));
        });
    }
}
/**
 * Función que limpia el reducer de Translator
 */
export const actionCleanTranslator = () => {
    return dispatch => {
        dispatch(actionDispatch(TRANSLATOR_ACTIONS.CLEAN));
    }
}
